<div class="col-md-12 filter-expander" [hidden]="section.key === 'nosection' || section.additionalRow">
  <a [hidden]="section.key === 'nosection' || section.additionalRow" (click)="toggleOpen()">
    <fa-icon [icon]="faChevronDown" [hidden]="!section.open"></fa-icon>
    <fa-icon [icon]="faChevronUp" [hidden]="section.open"></fa-icon>
    {{ section.name }}
  </a>
</div>
